import React from 'react';
import './personalinformation.scss';

const PersonalInformationViewPanel = ({
  userName,
  userEmail,
  firstName,
  lastName,
  userType,
  handleRedirect = null,
  stepNumber,
  userTypeLabel,
}) => {
  return (
    <div className="personal-Info-container mt-4">
      <div className="user-details-type">
        <div className="user-details">
          {/*<div className="user-name">
            <span>Name: </span><span className='user-value'>{userName}</span>
          </div>
          <div>
            <span>Email: </span><span className='user-value'>{userEmail}</span>
          </div> */}
          {firstName && lastName && (
            <div className="user-icon">
              <span>{firstName.charAt(0) + lastName.charAt(0)}</span>
            </div>
          )}
          <div className="user-name-email">
            <div className="user-name">{userName}</div>
            <div className="user-email">{userEmail}</div>
            {handleRedirect && (
              <div className="edit-label">
                <button
                  className="button-link p-0"
                  type="button"
                  onClick={(e) => handleRedirect(stepNumber)}
                >
                  Edit
                </button>
              </div>
            )}
          </div>
        </div>
        {userTypeLabel && (
          <div>
            {/*<div className="user-type-label">User Type</div><div className="user-type-value">{userType === "Client" ? "Employer" : userType}</div>*/}
            <div className="user-type-label">User Type</div>
            <div className="user-type-value">{userTypeLabel}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PersonalInformationViewPanel;
